<template>
  <div v-if="form" class="left-stepper">
    <div v-if="store.isMobile && !(store.stepNb === 0 && store.sectionNb === 0)" class="absolute mobile-back-button lg:hidden">
      <SvgIconComponent name="retour" directory="Icone24" css-class="" @click="goToPreviousStep()" />
    </div>
    <div class="lg:hidden h-4rem w-full justify-content-center align-items-center flex bg-white">
      <img
        :class="[store.form.x_eddy ? 'logo-x' : 'logo']"
        :src="getImgUrl(`${useRuntimeConfig().public.appUrl}/imgs/logos/${store.form.intro.logo_folder}/logo.png`)"
      >
    </div>
    <div :class="['logos lg:col-4 lg:block mt-6 p-0 hidden', form.x_eddy ? 'mx-auto lg:col-10' : 'ml-8 lg:col-4']" style="width: fit-content">
      <NuxtLink v-if="!form.x_eddy" :to="form.x_eddy ? '' : baseUrl">
        <img
          class="logo"
          :src="getImgUrl(`${useRuntimeConfig().public.appUrl}/imgs/logos/${store.form.intro.logo_folder}/logo.png`)"
        >
      </NuxtLink>
      <img
        v-else
        class="logo-x"
        :src="getImgUrl(`${useRuntimeConfig().public.appUrl}/imgs/logos/${store.form.intro.logo_folder}/logo.png`)"
      >
    </div>
    <div class="stepper-steps lg:mt-5 ml-0 mr-0 grid" :style="[ store.useGoogleReviewsDesktop ? 'height: 80%;' : 'height: 100%;' ]">
      <div
        v-for="(step, stepIndex) in form.steps"
        :key="stepIndex"
        :style="{height: !store.isMobile && stepIndex < Object.entries(form.steps).length - 1 ? (100/Object.entries(form.steps).length) + '% !important' : ''}"
        :class="[
          'step grid justify-content-center ml-0 mr-0 col-12 p-0 text-center lg:text-left lg:flex mt-2 mb-2',
          store.stepNb === parseInt(stepIndex as unknown as string) ? 'step-selected' : 'hidden'
        ]"
      >
        <div class="col-12 grid justify-content-center fit-content">
          <div class="step-box col-2 lg:col-1 lg:col-offset-1 lg:flex hidden align-items-center">
            <span v-if="store.stepNb <= parseInt(stepIndex as unknown as string)" class="title-2"> {{ parseInt(stepIndex as unknown as string) + 1 }} </span>
            <SvgIconComponent v-else name="valider" directory="Icone24" />
          </div>
          <div
            :class="[
              'subtitle lg:mt-3 lg:ml-3 lg:block',
              store.stepNb === parseInt(stepIndex as unknown as string) ? 'block' : 'hidden',
              store.noIntro === 'true' && store.isMobile === false ? 'col-offset-2 col-6' : 'lg:col-6 lg:col-offset-1 col-8'
            ]"
          >
            <span>{{ step.name }}</span>
          </div>
          <!-- <div class="col-2 lg:hidden"> -->
          <!-- <NuxtLink :to="store.form.url">
              <SvgIconComponent name="fermer" directory="Icone24" css-class="close-icon" />
            </NuxtLink> -->
          <!-- </div> -->
        <!-- </div> -->
        </div>
        <div class="col-12 grid justify-content-center" :style="{height: !store.isMobile ? '50% !important' : ''}">
          <div class="align-content-center lg:col-12 ml-0 mr-0 lg:w-full w-6rem lg:block justify-content-between flex">
            <div v-for="(stp, stpIndex) in form.steps" :key="stpIndex" :class="[stpIndex === stepIndex ? 'h-full ml-1 mr-1' : '']">
              <div v-if="stpIndex === stepIndex" class="h-full">
                <div :class="['lg:w-full lg:h-full between-step-container grid mt-0', `w-${Object.entries(form.steps[stepIndex].sections).length - 1}rem`]">
                  <div
                    :style="{height: !store.isMobile && store.stepNb === parseInt(stepIndex as unknown as string) ? relativeSize + '% !important' : '', width: store.isMobile && store.stepNb === parseInt(stepIndex as unknown as string) ? relativeSize + '% !important' : ''}"
                    :class="[
                      'between-step lg:col-2 col p-0',
                      parseInt(stepIndex as unknown as string) <= store.stepNb ? 'align-items-center flex justify-content-center lg:h-full lg:w-full' : '',
                      store.stepNb === parseInt(stepIndex as unknown as string) ? `step-selected` : '',
                      parseInt(stepIndex as unknown as string) >= Object.entries(form.steps).length - 1 ? 'lg:hidden flex' : ''
                    ]"
                  />
                </div>
              </div>
              <div v-else class="lg:hidden flex">
                <div v-if="stpIndex < stepIndex" class="past-step-sections mr-2" />
                <div v-else class="next-step-sections ml-2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "@/stores/store";
import { Form } from "~~/types";

const route = useRoute();
const store = useStore();
const form = store.form as unknown as Form;

const relativeSize = computed(() => {
  const calculatedSize = 100 / Object.entries(form.steps[store.stepNb].sections).length * (store.sectionNb + 1);
  return calculatedSize;
});

const baseUrl = computed(() => {
  if (process.client) {
    return window.location.origin;
  }
  return "";
});

function goToPreviousStep () {
  if (store.sectionNb > 0) {
    store.sectionNb = store.sectionNb - 1;
  } else if (store.sectionNb === 0 && store.stepNb > 0) {
    store.stepNb = store.stepNb - 1;
    store.sectionNb = form.steps[store.stepNb].sections.length - 1;
  } else if (store.stepNb === 0 && store.sectionNb === 0) {
    if (localStorage.getItem("noIntro") !== "true") {
      store.page = "";
      route.meta.layout = "default";
    }
  }
  saveNav();
}

function saveNav () {
  localStorage.setItem("stepNb", store.stepNb.toString());
  localStorage.setItem("sectionNb", store.sectionNb.toString());
}
</script>
